import type { Router, Url } from '@/domain/shared/types';
import type { NextRouter } from 'next/router';

export default function createNextRouter(router: NextRouter): Router {
  return {
    push: (url: Url) => router.push(url),
  };
}
